import { useQuery } from "@tanstack/react-query";

const API_BASE = process.env.REACT_APP_API_BASE;

const headers = {
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  },
};

export const fetchUsage = async (startDate, endDate) => {
  const endpoint = new URL(API_BASE + "/reporting/usage");
  endpoint.searchParams.append("start_date", startDate);
  endpoint.searchParams.append("end_date", endDate);
  const response = await fetch(endpoint.toString(), { headers });
  return response.json();
};

export const mlcUsageUrl = (startDate, endDate) => {
  const endpoint = new URL(API_BASE + "/reporting/mlc-usage.tsv");
  endpoint.searchParams.append("start_date", startDate);
  endpoint.searchParams.append("end_date", endDate);
  return endpoint.toString();
};

export const useUsage = (startDate, endDate) => {
  return useQuery({
    queryKey: ["usage", startDate, endDate],
    queryFn: () => fetchUsage(startDate, endDate),
  });
};

export const fetchSongs = async () => {
  const endpoint = new URL(API_BASE + "/reporting/songs");
  const response = await fetch(endpoint.toString(), { headers });
  return response.json();
};

export const useSongs = () => {
  return useQuery({
    queryKey: ["songs"],
    queryFn: () => fetchSongs(),
  });
};

export const fetchArtistSongs = async (artistKey) => {
  const endpoint = new URL(API_BASE + "/reporting/artist-songs");
  endpoint.searchParams.append("artist_key", artistKey);
  const response = await fetch(endpoint.toString(), { headers });
  return response.json();
};

export const useArtistSongs = (artistKey) => {
  return useQuery({
    queryKey: ["artist-songs", artistKey],
    queryFn: () => fetchArtistSongs(artistKey),
  });
};
